import { Component } from '@angular/core';
import { UilabMatFabButton } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface FabExample {
    readonly variant: 'basic';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
    readonly previewText: string;
    readonly extended: boolean;
}

@Component({
    selector: 'avd-fab-examples',
    templateUrl: './fab-examples.component.html',
    styleUrls: ['./fab-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatFabButton,
    ],
})
export class FabExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink = `${COMPONENT_EXAMPLES_CONSTANTS.STORYBOOK_BASE_URL}/?path=/story/components-buttons-fab--default`;
    readonly repoLink = `${COMPONENT_EXAMPLES_CONSTANTS.AZURE_DEVOPS_BASE_URL}&path=/projects/components/src/lib/buttons/fab`;

    readonly examples: readonly FabExample[] = [
        {
            variant: 'basic',
            label: 'Basic FAB',
            description:
                'Use a FAB for the single primary action on a screen, such as create or submit.',
            htmlSnippet: `<button uilabMatFab [extended]="true">Submit</button>`,
            previewText: 'Submit',
            extended: true,
        },
    ];
}
